<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title"><i class="back-btn" @click="goBack"></i>修改{{params.title}}</div>
    <div class="separator"></div>
    <div class="account-wrap setting-info">
    	<div class="wrap-item">
    		<span class="item-label">{{params.title}}： </span>
    		<input type="text" v-model="params.value" :placeholder="'请输入' + params.title" />
    	</div>
    	<div class="tusd-btn" @click="goBack">确认</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'editIpt',
  data(){
  	return {
  		params:{}
  	}
  },
  methods:{
  	goBack(){
  		this.$store.commit('setParam',{
				name:this.params.back,
				prop:this.params.prop,
				value:this.params.value
			})
  		this.$router.push({name:this.params.back})
  	}
  },
  created(){
  	this.params = this.$store.state.routerStore.editIpt
  }
}
</script>

<style lang="less" scoped>
	.wrap-item{
		margin-bottom: 60px;
	}
</style>
